import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    fontSize: '15px',
  },
  button: {
    marginTop: '2px',
    '&:focus-visible': {
      outline: '2px solid rgb(0, 0, 0)',
      outlineOffset: '-2px',
    },
  },
}));
